// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210904/js/" + chunkId + "." + {"44":"778454ee","225":"42e451c5","481":"a969c48f","486":"dafb6311","770":"0fb352b8"}[chunkId] + ".0.1292259416067384.chunk.js";
};